import React from 'react'

import Form from 'antd/es/form'
import Input from 'antd/es/input'
import Button from 'components/button'

import { Logo } from '../logo'
import preval from 'preval.macro'
import moment from 'moment'
import './style.css'
import Notification from 'antd/es/notification'
import axios from 'axios'
import { useParams, useHistory } from 'react-router-dom'

export type passwords = {
  password: string
  password2: string
}

export interface RouteParams {
  token: string
}

type Props = {
  logoUrl: string
  backgroundUrl: string
}

const dateTimeStamp = preval`module.exports = new Date();`

export const ResetPasswordScreen = (props: Props) => {
  let { token } = useParams<RouteParams>()
  const history = useHistory()

  const onFinish = async (item: passwords) => {
    if (item.password !== item.password2) {
      Notification.error({ message: 'salasanat eivät täsmää', placement: 'bottomLeft' })
    } else {
      await resetPasswordWithToken(token, item.password)
    }
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  const resetPasswordWithToken = async (token: string, newPassword: string) => {
    try {
      await axios.post(global.Config.backendUri + '/resetPasswordToken', { token, newPassword }).then(() => {
        Notification.success({ message: 'Salasana vaihdettu!', placement: 'bottomLeft' })
        history.push('/')
      })
    } catch (e) {
      console.log(e)
      Notification.error({ message: JSON.stringify(e), placement: 'bottomLeft' })
    }
  }

  return (
    <div className="c-reset-password__wrapper">
      <div className="c-reset-password-background" style={{ backgroundImage: `url(${window.origin + props.backgroundUrl}` }}></div>
      <div className="c-reset-password__version__timestamp">Versio: {moment(dateTimeStamp).format('DD.MM.YYYY HH:mm ')}</div>
      <div className="c-reset-password">
        <Logo imageUrl={props.logoUrl} style={{ marginRight: '8em', marginBottom: '3em' }} />
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item name="password" rules={[{ required: true, message: 'Anna Salasana!' }]}>
            <Input placeholder="Salasana" style={{ width: '200px' }} />
          </Form.Item>
          <Form.Item name="password2" rules={[{ required: true, message: 'Anna Salasana!' }]}>
            <Input placeholder="Salasana uudelleen" style={{ width: '200px' }} />
          </Form.Item>
          {/*
                    <Form.Item name="remember" valuePropName="checked" wrapperCol={{ offset: 8, span: 16 }}>
                        <Checkbox>Remember me</Checkbox>
                    </Form.Item> */}

          <Form.Item wrapperCol={{ offset: 8, span: 16 }} style={{ marginTop: '1em' }}>
            <Button label="Nollaa" type="submit" color="green" onClick={() => {}} style={{ marginTop: '3em' }} />
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}
